export function isLoggedIn() {
   // Object.keys(JSON.parse(sessionStorage.getItem('userData')))
   //  return !!Object.keys(JSON.parse(sessionStorage.getItem('userData'))).length;
    // return Object.keys(JSON.parse(sessionStorage.getItem('userData'))).length === 17;
    return !!sessionStorage.getItem('token');
}
